var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrademarkRegistered = function SvgIconTrademarkRegistered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8.25a1 1 0 0 1 1-1h3a3.25 3.25 0 0 1 1.727 6.003l1.343 1.925a1 1 0 0 1-1.64 1.144l-1.795-2.572H10.75v2a1 1 0 1 1-2 0zm4.153 3.49q-.07 0-.14.01H10.75v-2.5h2a1.25 1.25 0 0 1 .153 2.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
  }))));
};
export default SvgIconTrademarkRegistered;